// extracted by mini-css-extract-plugin
export default {"wrapperNotFound":"style_wrapperNotFound__GL4R3","button":"style_button__VFtNb","relativeElement":"style_relativeElement__sk8aF"};